import React, { Component, Fragment } from 'react'

/** Component */
import { Header, MyImage, Copyright, Navigation, NavBar } from 'components'

/** Images */
import { nectarpub, mailingbox } from 'images'

export default class Nectar extends Component {
	constructor(props) {
		super(props)
		this.state = {
			enlink: '/en/nectar',
			headertitle: 'Nectar',
			headertext:
				"Identité graphique complète, en cours pour une compagnie Suisse d'abonnement de vin.",
			copyright: '© 2019 Alexia Lechot',
			previouslink: '/fr/alexialechot',
			nextlink: '/fr/www',
		}
	}
	render() {
		const { enlink, headertitle, headertext, copyright, previouslink, nextlink } = this.state
		return (
			<Fragment>
				{/* NAVBAR */}
				<NavBar englishlink={enlink} />

				<div className="bg-white">
					<Header title={headertitle} text={headertext} image={nectarpub} />
					<MyImage image={mailingbox} />
					<Copyright text={copyright} />
					<Navigation previous={previouslink} next={nextlink} />
				</div>
			</Fragment>
		)
	}
}
